import React from "react";

import classNames from "classnames";

import {
  matchPath,
  useLocation,
  useResolvedPath,
  Link,
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";

type ItemProps = {
  icon: IconDefinition;
  children: React.ReactNode;
  to: string;
  matchPaths: string[];
  matchPathsExclude?: string[];
  className?: string;
};

const NavItem: React.FunctionComponent<ItemProps> = ({
  icon,
  children,
  to,
  matchPaths,
  matchPathsExclude,
  className,
}) => {
  const locationPathname = useLocation().pathname.toLowerCase();
  const toPathname = useResolvedPath(to).pathname.toLowerCase();

  const isActive =
    locationPathname === toPathname ||
    (matchPaths.findIndex((p) => matchPath(p, locationPathname)) != -1 &&
      (!matchPathsExclude ||
        matchPathsExclude.findIndex((p) => matchPath(p, locationPathname)) ==
          -1));

  const isExternal =
    /^https?\/\//.test(to) && new URL(to).host != window.location.host;
  const content = (
    <>
      <FontAwesomeIcon
        icon={icon}
        className="mr-2 inline-block h-[14px] w-[14px]"
      />
      <span className="ml-1">{children}</span>
    </>
  );

  return (
    <li className={classNames("relative", className)}>
      {isExternal ? (
        <a
          href={to}
          target="_blank"
          className={classNames(
            "block py-[10px] pl-[15px] hover:text-white focus:text-white",
            isActive ? "text-white" : "text-[var(--color-blue-150)]",
          )}
        >
          {content}
        </a>
      ) : (
        <Link
          aria-current={isActive ? "page" : undefined}
          className={classNames(
            "block py-[10px] pl-[15px] hover:text-white focus:text-white",
            isActive ? "text-white" : "text-[var(--color-blue-150)]",
          )}
          to={to}
        >
          {content}
        </Link>
      )}
    </li>
  );
};

export default NavItem;
